// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HorizontalRule, LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Typography, { TypographyProps } from "@store/MobiusOverrides/Typography/Typography";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    mainTitle = "mainTitle",
    titleOne = "titleOne",
    descriptionOne = "descriptionOne",
    imageOne = "imageOne",
    destinationOne = "destinationOne",
    overrideTitleOne = "overrideTitleOne",
    titleTwo = "titleTwo",
    descriptionTwo = "descriptionTwo",
    imageTwo = "imageTwo",
    destinationTwo = "destinationTwo",
    overrideTitleTwo = "overrideTitleTwo",
    titleThree = "titleThree",
    descriptionThree = "descriptionThree",
    imageThree = "imageThree",
    destinationThree = "destinationThree",
    overrideTitleThree = "overrideTitleThree",
    titleFour = "titleFour",
    descriptionFour = "descriptionFour",
    imageFour = "imageFour",
    destinationFour = "destinationFour",
    overrideTitleFour = "overrideTitleFour",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.mainTitle]: string;
        [fields.titleOne]: string;
        [fields.descriptionOne]: string;
        [fields.imageOne]: string;
        [fields.destinationOne]: LinkFieldValue;
        [fields.titleTwo]: string;
        [fields.descriptionTwo]: string;
        [fields.imageTwo]: string;
        [fields.destinationTwo]: LinkFieldValue;
        [fields.titleThree]: string;
        [fields.descriptionThree]: string;
        [fields.imageThree]: string;
        [fields.destinationThree]: LinkFieldValue;
        [fields.titleFour]: string;
        [fields.descriptionFour]: string;
        [fields.imageFour]: string;
        [fields.destinationFour]: LinkFieldValue;
    };
}

interface MosaicItem {
    description?: string;
    destination: LinkFieldValue;
    image: string;
    title?: string;
}

export interface MosaicStyles {
    title?: TypographyProps;
    gridContainer?: GridContainerProps;
    titleGridItem?: GridItemProps;
    mosaicGridItem?: GridItemProps;
    mosaicLinkWrapper?: InjectableCss;
    mosaicLink?: InjectableCss;
    mosaicLinkContent?: InjectableCss;
    mosaicTitle?: InjectableCss;
    mosaicDescription?: InjectableCss;
}

export const mosaicStyles: MosaicStyles = {
    title: {
        css: css`
            width: 100%;
            text-align: center;
            padding-bottom: ${x => x.theme.design.typography.spacing.base};
        `,
    },
    titleGridItem: {
        width: 12,
        css: css`
            text-align: center;
        `,
    },
    mosaicGridItem: {
        width: [12, 6, 6, 3, 3],
        css: css`
            position: relative;
        `,
    },
    mosaicLinkWrapper: {
        css: css`
            width: 100%;
            padding-bottom: 80%;
            position: relative;
        `,
    },
    mosaicLink: {
        css: css`
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
        `,
    },
    mosaicLinkContent: {
        css: css`
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            padding: ${pxToRem(20)};
            background-image: linear-gradient(rgba(46, 46, 65, 0) 0%, rgba(46, 46, 65, 0.7) 100%);
        `,
    },
    mosaicTitle: {
        css: css`
            color: ${getColor("primary.contrast")};
            text-shadow: rgba(0, 0, 0, 0.5) ${pxToRem(1, 1, 2)};
        `,
    },
    mosaicDescription: {
        css: css`
            color: ${getColor("primary.contrast")};
            text-shadow: rgba(0, 0, 0, 0.5) ${pxToRem(1, 1, 2)};
        `,
    },
};

type Props = OwnProps & HasHistory;

const styles = mosaicStyles;

const Mosaic: FC<Props> = ({ fields, history }) => {
    const mosaicDataProps = (cell: string) => {
        const mosaicCell: any = [];
        Object.entries(fields).map(([key, value]) => {
            if (key.endsWith(cell) && key.startsWith("title")) {
                mosaicCell["title"] = value;
            }
            if (key.endsWith(cell) && key.startsWith("description")) {
                mosaicCell["description"] = value;
            }
            if (key.endsWith(cell) && key.startsWith("image")) {
                mosaicCell["image"] = value;
            }
            if (key.endsWith(cell) && key.startsWith("destination")) {
                mosaicCell["destination"] = value;
            }
            return value;
        });
        return mosaicCell;
    };

    const mosaicData: any = {
        One: mosaicDataProps("One"),
        Two: mosaicDataProps("Two"),
        Three: mosaicDataProps("Three"),
        Four: mosaicDataProps("Four"),
    };

    const mosaicGridItem = (item: MosaicItem) => {
        const { url } = useGetLink(item["destination"]);
        const mosaicLink = css`
            ${styles.mosaicLink?.css}
            cursor: pointer;
            transition: opacity 0.2s ease-in-out;
            &:hover {
                opacity: 0.8;
            }
            background-image: url(${item["image"]});
        `;
        const mosaicStatic = css`
            ${styles.mosaicLink?.css}
            background-image:url(${item["image"]});
        `;
        const clickHandler = () => {
            if (url) {
                history.push(url);
            }
        };

        return (
            <GridItem {...styles.mosaicGridItem}>
                <StyledWrapper {...styles.mosaicLinkWrapper}>
                    <StyledWrapper css={url ? mosaicLink : mosaicStatic} onClick={clickHandler}>
                        <StyledWrapper {...styles.mosaicLinkContent}>
                            {item["title"] && (
                                <Typography variant="h3" {...styles.mosaicTitle}>
                                    {item["title"]}
                                </Typography>
                            )}
                            {item["description"] && (
                                <Typography variant="p" {...styles.mosaicDescription}>
                                    {item["description"]}
                                </Typography>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </GridItem>
        );
    };

    return (
        <>
            {fields.mainTitle && (
                <GridContainer {...styles.gridContainer}>
                    <GridItem {...styles.titleGridItem}>
                        <Typography variant="h2" {...styles.title}>
                            {fields.mainTitle}
                        </Typography>
                    </GridItem>
                </GridContainer>
            )}
            <GridContainer {...styles.gridContainer}>
                {Object.keys(mosaicData).map(key => {
                    return mosaicGridItem(mosaicData[key]);
                })}
            </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(Mosaic),
    definition: {
        displayName: "Mosaic",
        icon: "image",
        fieldDefinitions: [
            {
                name: fields.mainTitle,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 1,
                isRequired: true,
            },
            {
                ...HorizontalRule,
                sortOrder: 2,
            },
            {
                name: fields.titleOne,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 3,
            },
            {
                name: fields.descriptionOne,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 4,
            },
            {
                name: fields.imageOne,
                fieldType: "Contextual",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                sortOrder: 5,
                isRequired: true,
            },
            {
                name: fields.destinationOne,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                sortOrder: 6,
            },
            {
                ...HorizontalRule,
                sortOrder: 8,
            },
            {
                name: fields.titleTwo,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 9,
            },
            {
                name: fields.descriptionTwo,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 10,
            },
            {
                name: fields.imageTwo,
                fieldType: "Contextual",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                sortOrder: 11,
                isRequired: true,
            },
            {
                name: fields.destinationTwo,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                sortOrder: 12,
            },
            {
                ...HorizontalRule,
                sortOrder: 14,
            },
            {
                name: fields.titleThree,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 15,
            },
            {
                name: fields.descriptionThree,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 16,
            },
            {
                name: fields.imageThree,
                fieldType: "Contextual",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                sortOrder: 17,
                isRequired: true,
            },
            {
                name: fields.destinationThree,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                sortOrder: 18,
            },
            {
                ...HorizontalRule,
                sortOrder: 20,
            },
            {
                name: fields.titleFour,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 21,
            },
            {
                name: fields.descriptionFour,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 22,
            },
            {
                name: fields.imageFour,
                fieldType: "Contextual",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                sortOrder: 23,
                isRequired: true,
            },
            {
                name: fields.destinationFour,
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                fieldType: "General",
                sortOrder: 24,
            },
        ],
        group: "Common",
    },
};

export default widgetModule;
